import AmpLocale from './amp-locale-core';

const ampLocale = new AmpLocale();

export default ampLocale;

//# sourceMappingURL=amp-locale.js.map